import Card from "features/shared/components/card/Card";
import NavStepperItem from "features/shared/components/navs/NavStepperItem";
import IAppState from "infrastructure/store/IAppState";
import ContractingState from "infrastructure/store/contracting/ContractingState";
import React from "react";
import { useSelector } from "react-redux";
import ContractingStepConfiguration from "features/contracting/models/ContractingStepConfiguration";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

type Props = {
  steps: ContractingStepConfiguration[];
};

const ContractingStepper = ({ steps }: Props) => {
  // translations
  const tStepNames = useTranslation("contracting\\contractingStepNames").t;

  // router
  const location = useLocation();

  // store
  const storeStepsData = useSelector<IAppState, ContractingState>(
    (store) => store.contracting
  ).progress.steps;

  // helpers
  const getItemState = (
    stepConfig: ContractingStepConfiguration,
    stateType: "visited" | "completed"
  ): boolean => {
    const stepData = storeStepsData[stepConfig.component];

    if (stepData) {
      switch (stateType) {
        case "visited":
          return stepData.touched;
        case "completed":
          return stepData.valid;
        default:
          return false;
      }
    }

    return false;
  };

  const getActualStepName = () => {
    let step = steps.find(x => location.pathname.endsWith(x.route));

    if (step) {
      return tStepNames(step.title);
    }

    return "";
  };

  // render
  return (
    <Card className="mb-4 py-4">
      <div className="d-flex justify-content-between">
        {steps.map((step, index) => (
          <NavStepperItem
            number={index + 1}
            title={tStepNames(step.title)}
            routePath={`${step.route}`}
            key={index}
            visited={getItemState(step, "visited")}
            completed={getItemState(step, "completed")}
          />
        ))}
      </div>
      <h5 className="text-primary mb-0 mt-3 ml-3 d-sm-none">{getActualStepName()}</h5>
    </Card>
  );
};

export default ContractingStepper;
